// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3neRA","col":"styles_col__34Jup"};